import type { DroneTelemetry } from '@shared/types';

/**
 * 遥测帧总线。
 *
 * 每收到一帧就同步派发，**不经过 React**。姿态球、大数字等硬实时视图
 * 直接订阅总线并用 ref 写 DOM，从而在 20Hz 遥测下也不产生任何重渲染。
 * 需要走 React 渲染的内容则读 zustand store（按帧更新）。
 */
type FrameListener = (telemetry: DroneTelemetry) => void;

const listeners = new Map<string, Set<FrameListener>>();

export const telemetryBus = {
  /** 订阅某台无人机的每一帧，返回取消函数。 */
  on(droneId: string, listener: FrameListener): () => void {
    let set = listeners.get(droneId);
    if (!set) {
      set = new Set();
      listeners.set(droneId, set);
    }
    set.add(listener);
    return () => {
      const current = listeners.get(droneId);
      if (!current) return;
      current.delete(listener);
      if (current.size === 0) listeners.delete(droneId);
    };
  },

  emit(droneId: string, telemetry: DroneTelemetry): void {
    const set = listeners.get(droneId);
    if (!set) return;
    for (const listener of set) {
      try {
        listener(telemetry);
      } catch (error) {
        console.error('[havorix] 遥测监听器抛错', error);
      }
    }
  },

  clear(droneId?: string): void {
    if (droneId === undefined) listeners.clear();
    else listeners.delete(droneId);
  },
};
